import type SemanticTheme from '@/styles/SemanticTheme'

import ButtonStyles from './Button.json'

const theme: SemanticTheme = {
  layoutGap: '4',
  mainTextColor: 'gray.900',
  tabMaxWidth: 'auto',

  buttonNormalBg: 'seco.500',
  buttonNormalColor:
    ButtonStyles.baseStyle.colorScheme['fill-prim']['--btn-text'],

  switchNormalColor: 'prim.500',
  switchCheckedColor: 'seco.500',
  switchTextColor: 'gray.600',

  plinkoBG: [13, 18, 27],
  plinkoTagBg: [27, 34, 51],

  minesStepBox: {
    border: '1px solid #fff',
    borderColor: 'gray.300',
  },
  minesStepBoxActive: {
    border: '1px solid #fff',
    borderColor: 'prim.500',
  },
  minesStepTop: {
    bgColor: ['white', 'gray.300'],
    color: 'gray.900',
    border: 'none',
  },
  minesStepTopActive: {
    bgColor: 'prim.500',
    color: '#fff',
  },

  minesStepBottom: {
    color: 'gray.700',
  },
  minesStepBottomActive: {
    color: 'prim.500',
  },

  starsStepBox: {
    border: '1px solid #fff',
    borderColor: 'gray.300',
  },
  starsStepBoxActive: {
    border: '1px solid #fff',
    borderColor: 'prim.500',
  },
  starsStepTop: {
    bgColor: ['white', 'gray.300'],
    color: 'gray.900',
    border: 'none',
  },
  starsStepTopActive: {
    bgColor: 'prim.500',
    color: '#fff',
  },
  starsStepBottom: {
    color: 'gray.700',
  },
  starsStepBottomActive: {
    color: 'prim.500',
  },

  autoPick: {
    flex: '1',
    h: '50px',
    borderRadius: '10px',
    overflow: 'hidden',
    bgColor: 'seco.500',
    textAlign: 'center',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexBasis: '48%',
  },
  autoPickText: {
    fontWeight: '800',
    cursor: 'pointer',
    wordBreak: 'break-word',
    textAlign: 'center',
    maxW: '95%',
    lineHeight: '16px',
    color: 'white',
  },
  pickslot: {
    bgColor: 'prim.500',
    color: '#fff',
    borderRadius: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexBasis: '48%',
    paddingLeft: '3px',
    paddingRight: '3px',
  },
  pickSlotText: {
    lineHeight: '16px',
    fontWeight: '800',
    cursor: 'pointer',
    wordBreak: 'break-word',
    textAlign: 'center',
    maxW: '95%',
  },
  amountColor: 'prim.500',

  diceBg: 'gray.400',
  diceControlBg: 'gray.400',
  diceLuckyNumberBg: 'gray.400',
}

export default theme
